import React, { Fragment, useEffect, useState } from 'react'
import { DataGridRowTreeView } from '../../DataGrid/DataGridRowTreeView'
import { AsnBlogDetailAsn } from '../../AsnBlog/AsnBlogDetailAsn'
import { DataGridColumn } from '../../DataGrid/DataGridColumn'
import { Typography } from '@mui/material'
import { eAsnState } from '../../../enums/eAsnState'
import { AsnDetails } from '../AsnDetail/AsnDetails'
import { AsnDownload } from '../AsnDownload/AsnDownload'
import { AsnReservedDetails } from './AsnReservedDetails'
import { Asn } from '../../../interfaces/Asn/Asn'
import { ApiResponse } from '../../../typings/ApiResponse'
import { AsnDetailsReservedDto } from './api/dto'
import { useApi } from '../../../hooks/useApi'
import { getAsnDetails } from './api'
import { DataGridSettings } from '../../../interfaces/DataGrid/DataGridSettings'
import { AsnInfoReturnQuality } from './AsnInfoReturnQuatlity'
import { eTypeAsnProcess } from '../../../enums/eTypeAsnProcess'

interface AsnAccordionProps {
  element: Asn
  hideInfoReturnAsn?: boolean
}

const dataGridSettings: DataGridSettings = {
  spacing: 1,
  sortingMode: 'single',
  columns: []
}

export const AsnAccordion: React.FC<AsnAccordionProps> = ({
  element,
  hideInfoReturnAsn
}) => {
  const { callApi, state } = useApi<ApiResponse<AsnDetailsReservedDto>>()
  const [isQualityControlOpen, setIsQualityControlOpen] = useState(false)

  const requestAsnReservedDetails = (
    page: number,
    pageSize: number,
    sku: string
  ) => {
    callApi(getAsnDetails(element.asnId, sku, page, pageSize))
  }

  // en muestra pestaña de control calidad para devoluciones
  const showControlQuality = (): boolean => {
    if (hideInfoReturnAsn) {
      if (
        element.asnStateId === eAsnState.Controlled ||
        element.asnStateId === eAsnState.Finished
      ) {
        return true
      }
    }

    return false
  }

  useEffect(() => {
    if (
      element.typeAsnProcessId == eTypeAsnProcess.Replenishment &&
      element.asnStateId === eAsnState.FinishedIncompleteES
    ) {
      requestAsnReservedDetails(0, 5, '')
    }

    // Abrir la pestaña de Control de Calidad al cargar si hideInfoReturnAsn es true
    if (hideInfoReturnAsn && showControlQuality()) {
      setIsQualityControlOpen(true)
    }
  }, [])

  const handleQualityControlToggle = () => {
    setIsQualityControlOpen((prev) => !prev)
  }

  return (
    <Fragment>
      {!hideInfoReturnAsn && (
        <DataGridRowTreeView
          details={
            <div style={{ paddingTop: '10px' }}>
              <AsnBlogDetailAsn
                asnId={element.asnId}
                asnNumber={element.asnNumber}
              />
            </div>
          }
          onClick={() => console.log()}
        >
          <DataGridColumn datafield='' settings={dataGridSettings}>
            <Typography variant='h6' component='p'>
              Estados
            </Typography>
          </DataGridColumn>
        </DataGridRowTreeView>
      )}

      {!hideInfoReturnAsn && (
        <DataGridRowTreeView
          details={
            <div style={{ paddingTop: '10px' }}>
              <AsnDetails
                asnId={element.asnId}
                hideInfoReturnAsn={hideInfoReturnAsn}
              />
            </div>
          }
          onClick={() => console.log()}
        >
          <DataGridColumn datafield='' settings={dataGridSettings}>
            <Typography variant='h6' component='p'>
              Detalle
            </Typography>
          </DataGridColumn>
        </DataGridRowTreeView>
      )}

      {/* Información Calidad - cuando la Asn esta controlada */}
      {showControlQuality() && (
        <DataGridRowTreeView
          details={
            <div style={{ paddingTop: '10px' }}>
              <AsnInfoReturnQuality
                asnId={element.asnId}
                isAsnReturn={hideInfoReturnAsn}
              />
            </div>
          }
          onClick={handleQualityControlToggle}
          expanded={isQualityControlOpen}
        >
          <DataGridColumn datafield='' settings={dataGridSettings}>
            <Typography variant='h6' component='p'>
              Control de Calidad
            </Typography>
          </DataGridColumn>
        </DataGridRowTreeView>
      )}

      {element.typeAsnProcessId == eTypeAsnProcess.Inbound && (
        <DataGridRowTreeView
          details={
            <div style={{ paddingTop: '10px' }}>
              <AsnDownload
                id={element.packingListId || element.asnId}
                hideInfoReturnAsn={hideInfoReturnAsn}
              />
            </div>
          }
          onClick={() => console.log()}
        >
          <DataGridColumn datafield='' settings={dataGridSettings}>
            <Typography variant='h6' component='p'>
              Descargas
            </Typography>
          </DataGridColumn>
        </DataGridRowTreeView>
      )}

      {element.asnStateId === eAsnState.FinishedIncompleteES && (
        <DataGridRowTreeView
          details={
            <div style={{ paddingTop: '10px' }}>
              <AsnReservedDetails
                state={state}
                getReservedElements={requestAsnReservedDetails}
              />
            </div>
          }
          onClick={() => console.log()}
        >
          <DataGridColumn datafield='' settings={dataGridSettings}>
            <Typography variant='h6' component='p'>
              Detalle no almacenados
            </Typography>
          </DataGridColumn>
        </DataGridRowTreeView>
      )}
    </Fragment>
  )
}
